import {BehaviorSubject} from 'rxjs';

export class SharedDetailObject<T> {

  private id: string|null;
  private subject: BehaviorSubject<T|null>;

  constructor() {
    this.id = null;
    this.subject = new BehaviorSubject<T|null>(null);
  }

  getId(): string|null {
    return this.id;
  }

  setId(value: string): void {
    this.id = value;
  }

  getSubject(): BehaviorSubject<T|null> {
    return this.subject;
  }

  updateSubject(value: T|null): void {
    this.subject.next(value);
  }

  error(err: any): void {
    this.subject.error(err);
    this.subject = new BehaviorSubject<T|null>(null); // check
  }

  reset(): void {
    this.id = null;
    this.updateSubject(null);
  }

  // renewSubject() {
  //   this.subject. = new BehaviorSubject<T>(null);
  // }
}
